import { ref } from 'vue';

import type { ObjectField } from '../types';

import { useAccountProductMappingApi } from './useAccountProductMappingApi';

export type ObjectFieldsStatus =
  | 'idle'
  | 'loading'
  | 'loaded'
  | 'failed'
  | 'stale';

const STALE_OBJECT_STATUSES = [400, 404];

export function useObjectFields(feedId: () => number) {
  const { getObjectFields } = useAccountProductMappingApi();

  const status = ref<ObjectFieldsStatus>('idle');
  const fields = ref<ObjectField[]>([]);

  let latestRequestToken = 0;

  function reset() {
    latestRequestToken += 1;
    fields.value = [];
    status.value = 'idle';
  }

  async function load(apiName: string) {
    latestRequestToken += 1;
    const requestToken = latestRequestToken;

    fields.value = [];
    status.value = 'loading';

    const result = await getObjectFields(feedId(), apiName);
    if (requestToken !== latestRequestToken) return;

    if (result.status === 200 && result.data) {
      fields.value = result.data.items;
      status.value = 'loaded';
      return;
    }

    status.value = STALE_OBJECT_STATUSES.includes(result.status)
      ? 'stale'
      : 'failed';
  }

  return { status, fields, load, reset };
}
